export const Role = {
    Marina: 'marina',
    Kiosko: 'kiosko',
    Editor: 'editor-admin',
    Consulta: 'editor-consulta',
    Distribuidor: 'distribuidor'
}